"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var color_pallete_component_module_1 = __importDefault(require("@redwallsolutions/color-pallete-component-module"));

var styled_theming_1 = __importDefault(require("styled-theming"));

exports.createThemeWithAppearance = function (additionalTheme) {
  return styled_theming_1["default"].variants('mode', 'appearance', __assign(__assign({}, additionalTheme), {
    primary: {
      light: {
        color: function color(props) {
          return props.theme.primary || color_pallete_component_module_1["default"].primary;
        },
        contrast: function contrast(props) {
          return props.theme.primaryContrast || color_pallete_component_module_1["default"].primaryContrast;
        }
      },
      dark: {
        color: function color(props) {
          return props.theme.primaryDark || color_pallete_component_module_1["default"].primaryDark;
        },
        contrast: function contrast(props) {
          return props.theme.primaryContrastDark || color_pallete_component_module_1["default"].primaryContrastDark;
        }
      }
    },
    secondary: {
      light: {
        color: function color(props) {
          return props.theme.secondary || color_pallete_component_module_1["default"].secondary;
        },
        contrast: function contrast(props) {
          return props.theme.secondaryContrast || color_pallete_component_module_1["default"].secondaryContrast;
        }
      },
      dark: {
        color: function color(props) {
          return props.theme.secondaryDark || color_pallete_component_module_1["default"].secondaryDark;
        },
        contrast: function contrast(props) {
          return props.theme.secondaryContrastDark || color_pallete_component_module_1["default"].secondaryContrastDark;
        }
      }
    },
    "default": {
      light: {
        color: function color(props) {
          return props.theme["default"] || color_pallete_component_module_1["default"]._default;
        },
        contrast: function contrast(props) {
          return props.theme.defaultContrast || color_pallete_component_module_1["default"].defaultContrast;
        }
      },
      dark: {
        color: function color(props) {
          return props.theme.defaultDark || color_pallete_component_module_1["default"].defaultDark;
        },
        contrast: function contrast(props) {
          return props.theme.defaultContrastDark || color_pallete_component_module_1["default"].defaultContrastDark;
        }
      }
    }
  }));
};